export class DebitoAutomaticoContratoDetalhe {
  /**
   * Numero do Contrato
   */
  nuContrato: number;
  /**
   * Data do Contrato
   */
  dataContrato: string;
  /**
   * Quantidade de Parcelas
   */
  quantidadeParcelas: string;
  /**
   * Forma de Pagamento (Fixo)
   */
  modalidade: string;
  /**
   * Taxa de Juros
   */
  txJuros: string;
  /**
   * Multa
   */
  multa: string;
  /**
   * Encargos Remuneratorios
   */
  encargosRemuneratorios: string;
  /**
   * Encargos Moratorios
   */
  encargosMoratorios: string;
  /**
   * Optin limite
   */
  optinLimite: string = "";
  /**
   * Optin vencida
   */
  optinVencida: string = "";

  cdMsgemRetorno: string;
  dsMsgemRetorno: string;

  constructor() { }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/modelo/debito-automatico-contrato-detalhe.ts